import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import IncomeFromTheUsAttachments from './IncomeFromTheUS/attatchments';
import IncomeOutsideOfTheUSAttachments from './IncomeOutsideOfTheUS/attatchments';

export interface IWagesAttachmentsProps {}

export default function WagesAttachments(props: IWagesAttachmentsProps) {
  return (
    <div>
      <DashboardContainerHeader title="Income / Wages" />
      <IncomeFromTheUsAttachments />
      <IncomeOutsideOfTheUSAttachments />
    </div>
  );
}
